export const BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL || "https://fyk-django.fly.dev";
export const API_URL = `${BACKEND_URL}/api`
